import { LineOfBusinessTable } from "./view/LineOfBusinessTable";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import { PERMISSIONS } from "../../../PermissionsConstants";

const LineOfBusiness = () => {
  const userPermissions = useRecoilValue(permissionsSelector);
  const viewLOBPermission =
    PERMISSIONS.permission_utilities_configureagreement_lineofbusiness_view;
  return (
    <>{userPermissions.includes(viewLOBPermission) ? <LineOfBusinessTable /> : ""}</>
  );
};

export default LineOfBusiness;
